var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bulletin-container" }, [
    _c(
      "h1",
      [
        _vm._v("\n    Feladatok, információk\n\n    "),
        _vm.loading ? _c("a-icon", { attrs: { type: "loading" } }) : _vm._e()
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "bulletin-news-categories" },
      [
        _c(
          "a-button",
          {
            attrs: {
              type: "default",
              disabled:
                _vm.selectedCategoryIds.length === 0 &&
                (_vm.search === undefined || _vm.search.length === 0)
            },
            on: {
              click: function($event) {
                _vm.selectedCategoryIds = []
                _vm.search = undefined
              }
            }
          },
          [_vm._v("\n      Összes\n    ")]
        ),
        _c(
          "div",
          { staticClass: "bulletin-news-categories-buttons" },
          _vm._l(_vm.categories, function(category) {
            return _c(
              "a-button",
              {
                key: category.id,
                attrs: {
                  type:
                    _vm.selectedCategoryIds.indexOf(category.id) !== -1
                      ? "primary"
                      : "default"
                },
                on: {
                  click: function($event) {
                    return _vm.toggleCategory(category.id)
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(category.name) + "\n      ")]
            )
          }),
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "bulletin-news-search" },
      [
        _c("a-input", {
          attrs: { placeholder: "Keresés" },
          model: {
            value: _vm.search,
            callback: function($$v) {
              _vm.search = $$v
            },
            expression: "search"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "bulletin-news-container" },
      _vm._l(_vm.news, function(article) {
        return _c(
          "article",
          {
            key: article.id,
            class: {
              mandatory: article.mandatory,
              featured: _vm.isFeatured(article)
            }
          },
          [
            _vm.isFeatured(article)
              ? _c(
                  "div",
                  { staticClass: "article-featured" },
                  [
                    _c("a-icon", { attrs: { type: "warning" } }),
                    _vm._v("\n        Határidős feladat\n      ")
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "article-container" }, [
              _c("div", { staticClass: "article-image" }, [
                article.picture
                  ? _c("img", {
                      attrs: {
                        src:
                          "/api/v1/companies/1/images/" +
                          article.picture.id +
                          "/view?width=640",
                        alt: article.title
                      }
                    })
                  : _vm._e()
              ]),
              _c("div", { staticClass: "article-content" }, [
                _c("div", { staticClass: "article-info" }, [
                  _c("h2", [_vm._v(_vm._s(article.title))]),
                  _c(
                    "div",
                    { staticClass: "article-categories" },
                    _vm._l(article.categories, function(category) {
                      return _c("a-tag", { key: category.id }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(category.name) +
                            "\n              "
                        )
                      ])
                    }),
                    1
                  ),
                  _c("div", [
                    _vm._v(
                      "Közzétéve: " +
                        _vm._s(
                          _vm
                            .moment(article.date)
                            .format("YYYY.MM.DD")
                            .toString()
                        )
                    )
                  ]),
                  article.deadlineDate
                    ? _c("div", [
                        _vm._v("\n              Határidő:\n              "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm
                                .moment(article.deadlineDate)
                                .format("YYYY.MM.DD")
                                .toString()
                            )
                          )
                        ])
                      ])
                    : _vm._e(),
                  article.mandatory
                    ? _c(
                        "div",
                        { staticClass: "mandatory" },
                        [
                          _c("a-tag", { attrs: { color: "red" } }, [
                            _vm._v("Kötelező feladat")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _c(
                  "div",
                  { staticClass: "article-buttons" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: "/neta/bulletin/" + article.slug } },
                      [
                        _c("a-button", { attrs: { type: "primary" } }, [
                          _vm._v("\n                Tovább\n              ")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ]
        )
      }),
      0
    ),
    _vm.total > _vm.limit
      ? _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("a-pagination", {
              attrs: {
                total: _vm.total,
                "page-size": _vm.limit,
                "show-less-items": ""
              },
              model: {
                value: _vm.current,
                callback: function($$v) {
                  _vm.current = $$v
                },
                expression: "current"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }